export default {"src":"/_next/static/media/logo__chrono-black.ec69090f.svg","height":160,"width":922,"blurWidth":0,"blurHeight":0};